<template>
  <router-view />
</template>

<script setup>
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
</style>
